import { useTranslation } from 'react-i18next';
import { SettingsHubTile, SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/**
 * Settings › Pricing & quotes: one tile per pricing policy, each opening a
 * page that holds only that policy's card. They used to stack five deep under
 * one anchor, every card mounted (and fetching) at once; the mobile app has
 * always given each its own screen, and so does this.
 *
 * No gate of its own: pricing was always shown, and each card still decides
 * for itself what a read-only role may change.
 */

export const PRICING_PAGES = [
  { id: 'base', to: '/settings/pricing/base' },
  { id: 'area', to: '/settings/pricing/area' },
  { id: 'addOns', to: '/settings/pricing/add-ons' },
  { id: 'dust', to: '/settings/pricing/dust' },
  { id: 'walkthrough', to: '/settings/pricing/walkthrough' },
  { id: 'numbering', to: '/settings/pricing/numbering' },
] as const;

export default function PricingHubPage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.hubTitle')}
      description={t('settings.pricingPages.hubDescription')}
      back={{ to: '/settings', label: t('settings.pricingPages.backToSettings') }}
    >
      <ul className="grid gap-4 sm:grid-cols-2">
        {PRICING_PAGES.map((page) => (
          <SettingsHubTile
            key={page.id}
            to={page.to}
            title={t(`settings.pricingPages.tiles.${page.id}.title`)}
            description={t(`settings.pricingPages.tiles.${page.id}.description`)}
          />
        ))}
      </ul>
    </SettingsLeafPage>
  );
}
